import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {NameServerVO} from '../../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../../generate/ChangeVO';
import {UtilService} from '../../../../util/util.service';

@Component({
  selector: 'name-servers-view',
  templateUrl: './name-servers-view.component.html',
  styleUrls: ['./name-servers-view.component.scss']
})
export class NameServersViewComponent implements OnChanges {

  @Input()
  nameServers: Array<NameServerVO>;

  @Input()
  nsChange: ChangeVO;

  @Input()
  pendingRequestChangeID: string;

  @Input()
  lastchange: string;

  @Output()
  edit = new EventEmitter<boolean>();
  @Input()
  viewMode: boolean;
  hasSharedNameServers: boolean;

  constructor(private util: UtilService) {
  }

  ngOnChanges() {
    if (this.nsChange != null) {
      this.buildNSFromChangeVO();
    }
  }

  updateNameServers() {
    this.edit.emit(true);
  }

  private buildNSFromChangeVO() {
    this.nameServers = [];
    this.util.buildObjectFromChange(this.nameServers, this.nsChange);
    this.hasSharedNS();
  }


  private hasSharedNS() {
    this.hasSharedNameServers = this.nameServers.filter(ns => ns.shared === true).length > 0;
  }
}
